var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-group',{attrs:{"id":"input-group-1","label":_vm.field.label,"label-for":_vm.labelId}},[_c('b-form-input',{attrs:{"id":_vm.labelId,"type":"text","required":"","autocomplete":"no","placeholder":_vm.field.placeholder}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }